module.exports = __webpack_public_path__ + "media/images/lb/114-9163e68d4069c77bbb061e67f5ebaaf1.svg";